import React from 'react';

const FooterHours = () => (
  <div
    className="footer-boxes p-3 mb-3 mb-lg-0 border rounded w-100 align-items-stretch">
    <h5
      className="h4">
      Hours
    </h5>
    <div>
      <div
        className="d-flex justify-content-between">
        <p
          className="mb-3">Monday</p>
        <p
          className="mb-3">Closed</p>
      </div>
      <div
        className="d-flex justify-content-between">
        <p
          className="mb-3">Tuesday</p>
        <p
          className="mb-3">Closed</p>
      </div>
      <div
        className="d-flex justify-content-between">
        <p
          className="mb-3">Wednesday</p>
        <p
          className="mb-3">Closed</p>
      </div>
      <div
        className="d-flex justify-content-between">
        <p
          className="mb-3">Thursday</p>
        <p
          className="mb-3">Closed</p>
      </div>
      <div
        className="d-flex justify-content-between">
        <p
          className="mb-3">Friday</p>
        <p
          className="mb-3">Closed</p>
      </div>
      <div
        className="d-flex justify-content-between">
        <p
          className="mb-3">Saturday</p>
        <p
          className="mb-3">Closed</p>
      </div>
      <div
        className="d-flex justify-content-between">
        <p
          className="mb-0">Sunday</p>
        <p
          className="mb-0">Closed</p>
      </div>
    </div>
  </div>
);

export default FooterHours;
